module.exports = "<div js-tree=\"treeConfig\"\n     ng-model=\"tree\"\n     tree=\"data.treeInstance\"\n     tree-events=\"check_node:check;uncheck_node:check;\"></div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./components/formly/tree.template.html
 ** module id = 22
 ** module chunks = 0
 **/